export const messages = {
  en: {
    addAttendanceClassesStaff: {
      title: 'Add Attendance Classes Staff',
      staffName: 'Staff Name',
      staffNamePlaceholder: 'Required, please select staff',
      staffNameRequired: 'Staff name is required',
      attendanceFace: 'Attendance Face',
      submitSuccess: 'Add success',
      submitFailed: 'Add failed'
    },
    uploadImage: {
      imageSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Upload failed'
    },
    orgTree: {
      loadFailed: 'Failed to load organization tree'
    }
  },
  zh: {
    addAttendanceClassesStaff: {
      title: '添加考勤班次员工',
      staffName: '员工名称',
      staffNamePlaceholder: '必填，请选择员工',
      staffNameRequired: '员工名称不能为空',
      attendanceFace: '考勤人脸',
      submitSuccess: '添加成功',
      submitFailed: '添加失败'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '上传失败'
    },
orgTree: {
      loadFailed: '加载组织树失败'
    }
  },
  'zh-TW': {
    addAttendanceClassesStaff: {
      title: '添加考勤班次員工',
      staffName: '員工名稱',
      staffNamePlaceholder: '必填，請選擇員工',
      staffNameRequired: '員工名稱不能為空',
      attendanceFace: '考勤人臉',
      submitSuccess: '添加成功',
      submitFailed: '添加失敗'
    },
    uploadImage: {
      imageSizeLimit: '圖片大小不能超過2MB',
      uploadFailed: '上傳失敗'
    },
    orgTree: {
      loadFailed: '載入組織樹失敗'
    }
  }
}